// extracted by css-extract-rspack-plugin
export default {"readMoreButtonClass":"_49fdebea","expandingAreaWrapperClass":"_bb2fb1f9"};